import reframe, { dispatch } from 'nike-re-framejs';
import axios from 'axios';
import { lang } from '../turboLive/utils';
import { setBetradarLibLoaded } from './handlers';
import { getTabTemplateId } from '../turboLive/push/overview/handlers';

export function getImgEventCentreProperties() {
    const playBackAllowed =
        window.OPTIONS['imgEventCentreVideoPlaybackAllowed'] ||
        window.OPTIONS.properties['img.eventCentre.videoPlaybackAllowed'];
    const operatorId =
        window.OPTIONS['imgEventCentreOperatorId'] || window.OPTIONS.properties['img.eventCentre.operatorId'];
    return [playBackAllowed, operatorId];
}

export function isBetradarWidgetAvailable(sportEvent) {
    if (!sportEvent) {
        return null;
    }
    const templateId = getTabTemplateId(sportEvent);
    const templateData = reframe.appDb
        .peekValue()
        .getIn(['infocentrum', 'templates', templateId?.toString(), 'templates']);

    if (templateId && !templateData) {
        return null;
    }

    return templateData;
}

const BetradarStatisticsTabs = Object.freeze({
    MT_STATISTICS: 'statistics',
    HEAD_TO_HEAD: 'headToHead',
    TIMELINE: 'timeline',
    LEADERBOARD: 'leaderboard',
    STANDINGS: 'standings',
    MT_LINEUPS: 'lineups',
    GENERAL_STATISTICS: 'generalStatistics',
    GENERAL_TEAM_STATISTICS: 'generalTeamStatistics',
    MATCH_FACTS: 'matchFacts',
    VERTICAL_TIMELINE: 'verticalTimeline',
    COMMENTARY: 'commentary',
    TABLE: 'table',
    MATCH_LINEUPS: 'matchLineups',
    HEAT_MAP: 'heatMap',
    POINT_BY_POINT: 'pointByPoint',
    IMG_ARENA_EVENT_CENTRE: 'imgArenaEventCentre',
    TOP_LISTS: 'topLists',
    BOXSCORE: 'boxscore',
    PROBABILITIES: 'probabilities',
    MBM: 'mbm'
});

export default BetradarStatisticsTabs;

export const {
    MT_STATISTICS,
    HEAD_TO_HEAD,
    TIMELINE,
    LEADERBOARD,
    STANDINGS,
    GENERAL_STATISTICS,
    GENERAL_TEAM_STATISTICS,
    MATCH_FACTS,
    TABLE,
    VERTICAL_TIMELINE,
    COMMENTARY,
    MATCH_LINEUPS,
    HEAT_MAP,
    POINT_BY_POINT,
    IMG_ARENA_EVENT_CENTRE,
    TOP_LISTS,
    MT_LINEUPS,
    BOXSCORE,
    MBM
} = BetradarStatisticsTabs;

// Sports that are using widget scoreboard, not lmt scoreboard
export const SPORTS_WITH_WIDGET_SCOREBOARD = ['1', '3', '5', '7', '11', '13', '88', '89', '101'];
export const SPORTS_WITH_FULL_BR_SCOREBOARD = ['59', '87'];
export const SPORTS_WITH_SPORT_MT_ICON = ['39', '59', '61', '68', '85', '88', '101', '142'];

export const loadBetradarWidgetsLib = (callback?: any) => {
    /* eslint-disable */
    const existingScript = document.querySelector('script[n="SIR"]');
    //script from betradar - wanted to avoid it but seting theme after loading script causes not conflict in loading/reloading scripts
    if (!existingScript) {
        (function (a, b, c, d, e, f, g, h, i) {
            a[e] ||
                ((i = a[e] = function () {
                    (a[e].q = a[e].q || []).push(arguments);
                }),
                // @ts-ignore
                (i.l = 1 * new Date()),
                (i.o = f),
                (g = b.createElement(c)),
                (h = b.getElementsByTagName(c)[0]),
                (g.async = 1),
                (g.src = d),
                g.setAttribute('n', e),
                h.parentNode.insertBefore(g, h));
        })(
            window,
            document,
            'script',
            'https://widgets.sir.sportradar.com/e2b260cc50880382ca9893668d40b36e/widgetloader',
            'SIR',
            {
                language: lang,
                theme: 'betradar',
                logLevel: 'error'
            }
        );
        dispatch(setBetradarLibLoaded('lib', true));
        if (callback) callback(window.SIR);
    }
    if (existingScript && callback) callback(window.SIR);
};

export const isFullBetradarScoreboard = (sportId: number | string) =>
    SPORTS_WITH_FULL_BR_SCOREBOARD.includes(`${sportId}`);

export const isSportWithWidgetScoreboard = (sportId: number | string) =>
    SPORTS_WITH_WIDGET_SCOREBOARD.includes(`${sportId}`);

export const isMotorizmus = (sportId: number | string) => `${sportId}` === '87';

export const isUFC = (sportId: number | string) => `${sportId}` === '142';

export const isFootball = (sportId: number | string) => `${sportId}` === '1';

export const isHockey = (sportId: number | string) => `${sportId}` === '3';

export const isAmericanFootbal = (sportId: number | string) => `${sportId}` === '39';

export const sportIconAsMatchtrackerIcon = (sportId: number | string) =>
    SPORTS_WITH_SPORT_MT_ICON.includes(`${sportId}`);

export function getAuthTokenAndTimestamp(callback) {
    return axios.get('/api/live-stream/eventCentreAuth').then(response => callback(response));
}
